export default __webpack_public_path__ + "static/media/icon-document.33a52f03.svg";